module.exports = __webpack_public_path__ + "media/Video 78.db093751.mp4";